/**
 * Main javascript entry point
 * Should handle bootstrapping/starting application
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

/*global window, document, jQuery, $, require, alert, location, parent, global */
import 'promise-polyfill/src/polyfill';
import Application from './core/app';
import Form from './core/form';
import axios from 'axios';

/**
 * First we will load all of this project's JavaScript dependencies which
 * include jQuery, Bootstrap, slick-slider,
 * magnificPopup, sweetalert and
 * cookieconsent. This gives a great starting point for building
 * robust, powerful web applications.
 */

require('./bootstrap');

$(() => {
    $('#offcanvas').mmenu({
        'pageScroll': true,
        'extensions': [
        'theme-dark',
        'shadow-page',
        'pagedim-black',
        'border-full',
        'fx-menu-slide',
        'fx-listitems-slide'
        ]
    })
})


/**
 * Setup some globals for objects we'll be using across application.
 */
window.Form = Form;
window.axios = axios;

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

/**
 * Next, we will create a fresh Application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

let App = new Application();

/** Expose the App to browser window object */
window.App = App;


/**
 * Initialize the application on document ready. All code that needs
 * to be executed when page is done, should be handled from within the
 * Application init method.
 */

// $(() => {
//     App.init(); // App initialized in footer;
// })

$(document).ready(function() {
    $("#checkAll").click(function(){
        $('.checkItem').prop('checked', this.checked);
    });

    $("#herr").click(function(){
        $('#salutation').val("Herr");
        $('#salutationDD').text("Herr");
    });
    $("#frau").click(function(){
        $('#salutation').val("Frau");
        $('#salutationDD').text("Frau");
    });
    
    if($(window).width() < 1183) {
        if(document.getElementById('collapseCategories')) {
            document.getElementById('collapseCategories').classList.remove("show");
        }
    } else {
        if(document.getElementById('collapseCategories')) {
            document.getElementById('collapseCategories').classList.add("show");
        }
    }
});

$(window).resize(function() {
    if($(window).width() < 1183) {
        if(document.getElementById('collapseCategories')) {
            document.getElementById('collapseCategories').classList.remove("show");
        }
    } else {
        if(document.getElementById('collapseCategories')) {
            document.getElementById('collapseCategories').classList.add("show");
        }
    }
});